import { isMedicalRecordInvalidated } from '../../../utils/medicalRecordStatus';
import type { InitialAssessmentExternalExamSnapshot } from './initialAssessmentDomain';

export interface InitialAssessmentExternalExamRecord {
  recordId: string;
  clientId: string;
  patientId: string;
  recordType?: string | null;
  recordTitle?: string | null;
  recordDate?: string | null;
  recordUpdatedAt?: string | null;
  recordAttachments?: unknown;
}

/** Only public-to-the-record metadata is copied; attachment content and storage URLs are never included. */
export const buildInitialAssessmentExternalExamOptions = (
  records: readonly InitialAssessmentExternalExamRecord[],
  identity: { clientId: string; patientId: string },
): InitialAssessmentExternalExamSnapshot[] => {
  if (!identity.clientId || !identity.patientId) return [];
  const ids = new Set<string>();
  return records.flatMap((record) => {
    const recordId = typeof record.recordId === 'string' ? record.recordId.trim() : '';
    const recordDate = typeof record.recordDate === 'string' ? record.recordDate.trim() : '';
    if (!recordId || ids.has(recordId) || !recordDate || !Number.isFinite(Date.parse(recordDate))
      || record.clientId !== identity.clientId || record.patientId !== identity.patientId || record.recordType !== 'exam'
      || isMedicalRecordInvalidated(record.recordType, record.recordAttachments)) return [];
    ids.add(recordId);
    return [{
      recordId,
      title: typeof record.recordTitle === 'string' && record.recordTitle.trim() ? record.recordTitle.trim() : 'Exame complementar',
      recordDate,
      note: '',
      sourceUpdatedAt: typeof record.recordUpdatedAt === 'string' && Number.isFinite(Date.parse(record.recordUpdatedAt)) ? record.recordUpdatedAt : null,
    }];
  }).sort((a, b) => Date.parse(b.recordDate) - Date.parse(a.recordDate));
};
